import React, { useEffect } from 'react';
import ViewMessage from '@components/ViewMessage';
import { ActionMergeIcon, LoaderIcon } from '@repo/icons';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDuplicateStatus, startScanForDuplicates } from '@repo/redux/actions/duplicates';
import { selectScanInProgress } from '@repo/redux/reducers/data/duplicates';

export default function ClearedDuplicates() {
  const dispatch = useDispatch();
  const isScanning = useSelector(selectScanInProgress);

  let icon = <ActionMergeIcon color="textPrimary" width="18" height="22" hoverOpacity={false} />;
  let headline = 'No duplicates found';
  let message = 'Run a new scan or check back later.';
  let button = {
    text: 'Scan for Duplicates',
    onClick: () => dispatch(startScanForDuplicates()),
  };

  if (isScanning) {
    icon = <LoaderIcon color="textPrimary" width="18" height="22" />;
    headline = 'Looking for duplicates…';
    message = "We'll notify you when we're finished!";
    button = null;
  }

  // This will kick off polling if we *are* currently scanning and just haven't checked yet
  useEffect(() => {
    if (!isScanning) {
      dispatch(fetchDuplicateStatus());
    }
  }, []);

  return (
    <ViewMessage underHeader icon={icon} headline={headline} message={message} button={button} />
  );
}
